import React from 'react'
import HeroSection from '../../Components/Home/HeroSection'
import DiscoverTheUtlitmate from '../../Components/Common/DiscoverTheUtlitmate'
import GetToknow from '../../Components/Home/GetToknow'
import BestPlans from '../../Components/Home/BestPlans'
import WhatWeProvideHome from '../../Components/Home/WhatWeProvideHome'
import OurProfessionals from '../../Components/Common/OurProfessionals'
import BookYourService from '../../Components/Common/BookYourService'
import GetInTouch from '../../Components/Offers/GetInTouch'
import SpaTreatmentsWithPricing from '../../Components/Home/SpaTreatmentsWithPricing'
import WhatTheySay from '../../Components/Home/WhatTheySay'
import Gallery from '../../Components/Home/Gallery'
import MenuQR from '../../Components/Home/MenuQR'

const Home = () => {
  return (
    <div className='overflow-hidden'>
      <HeroSection />
      <DiscoverTheUtlitmate />
      <WhatWeProvideHome />
      <GetToknow />
      <SpaTreatmentsWithPricing />
      <BestPlans />
      {/* <MenuQR /> */}
      <Gallery />
      <WhatTheySay />
      <OurProfessionals />
      <GetInTouch />
      <BookYourService />
    </div>
  )
}

export default Home